import React from 'react'
import BorderColorIcon from '@material-ui/icons/BorderColor'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
    signatureIconRoot: {
        cursor: 'pointer',
        color: `#0091ff !important`,
    }
})

const DigitalSignatureBtn = (props) => {
    const {
        clickHandler,
        disabled
    } = props

    const classes = useStyles()
    return (<BorderColorIcon
        classes={{ root: classes.signatureIconRoot }}
        onClick={!disabled ? clickHandler : undefined}
        style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }}
    />)
}

export default DigitalSignatureBtn